import { render, staticRenderFns } from "./ModalBeyondGravity.vue?vue&type=template&id=1fe64890&scoped=true&"
import script from "./ModalBeyondGravity.vue?vue&type=script&lang=js&"
export * from "./ModalBeyondGravity.vue?vue&type=script&lang=js&"
import style0 from "./ModalBeyondGravity.vue?vue&type=style&index=0&id=1fe64890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe64890",
  null
  
)

export default component.exports